import { User } from "models";
import { USERS_MODALS } from "modules/Users/hooks";
import { useUserDelete } from "modules/Users/service";

type DeleteUserFormProps = {
  onClose: () => void;
  user: User;
  handleCloseModal: (modalName: USERS_MODALS) => void;
  handleOpenModal: (modalName: USERS_MODALS) => void;
};

export const useDeleteUser = ({ onClose, user, handleCloseModal, handleOpenModal }: DeleteUserFormProps) => {
  const { mutateAsync: deleteUserMutation, isPending: isDeleteLoading } = useUserDelete();

  const handleDeleteUser = () => {
    deleteUserMutation(user.id);
    onClose();
    handleCloseModal(USERS_MODALS.DeleteUserModal);
  };

  const handleDeleteUserClick = () => {
    handleOpenModal(USERS_MODALS.DeleteUserModal);
    handleCloseModal(USERS_MODALS.EditUserModal);
  };

  return { isDeleteLoading, handleDeleteUser, handleDeleteUserClick };
};
